export const CacheQueryTypes = {
  accountMetric: "AccountMetricQuery",
  address: "AddressQuery",
  agent: "AgentQuery",
  analytics: "AnalyticsQuery",
  afiliateProgram: "AfiliateProgramQuery",
  afiliateProgramPostulation: "AfiliateProgramPostulationQuery",
  appLabel: "AppLabelQuery",
  badge: "BadgeQuery",
  bankAccount: "BankAccountQuery",
  brand: "BrandQuery",
  campaign: "CampaignQuery",
  campaignDraft: "CampaignDraftQuery",
  campaignResource: "CampaignQuery",
  chat: "ChatQuery",
  contentApproval: "ContentApprovalQuery",
  countryCity: "CountryCityQuery",
  invitationCode: "InvitationCodeQuery",
  course: "CourseQuery",
  courseCategory: "CourseCategoryQuery",
  courseProgress: "CourseProgressQuery",
  curatedBrand: "CuratedBrandQuery",
  ecommerce: "EcommerceQuery",
  gamification: "GamificationQuery",
  generic: "GenericEnumsQuery",
  guest: "GuestQuery",
  invoice: "InvoiceQuery",
  lesson: "LessonQuery",
  lessonProgress: "LessonProgressQuery",
  mobileVersion: "MobileVersionQuery",
  notification: "NotificationQuery",
  payments: "PaymentsQuery",
  platform: "PlatformQuery",
  postulationResource: "PostulationQuery",
  postulationTag: "PostulationTagQuery",
  product: "ProductQuery",
  recommendation: "RecommendationQuery",
  report: "ReportQuery",
  review: "ReviewsQuery",
  skill: "SkillQuery",
  socialNetworkUser: "SocialNetworkUserQuery",
  subscription: "SubscriptionsQuery",
  teacher: "TeacherQuery",
  userBadge: "UserBadgeQuery",
  userResource: "UserQuery",
  userSkill: "UserSkillQuery",
  wallet: "WalletQuery",
  workOrder: "WorkOrderQuery",
  workspace: "WorkspaceQuery",
};
